module.exports = __webpack_public_path__ + "img/lock-rings.2ba2e193.png";